import { forwardRef, useContext } from "react";
import PageContainer, { PageContainerBase } from "../../../Common/Template/PageContainer";
import { SystemFieldType, SystemPageType } from "../../../../Model/SystemModels";
import { t } from "i18next";
import { CardGroup } from "../../../Common/Template/Card/CardGroup";
import { CardField } from "../../../Common/Template/Card/CardField";
import { PartnerInformationContext } from "../../../../ApplicationCode/Partner/PartnerInformationContext";

export const PartnerItemCard = forwardRef<PageContainerBase, React.PropsWithChildren<{}>>((props, ref) => {
    const partnerInfoContext = useContext(PartnerInformationContext);
    const buildItemFilter = () => "?$filter=legalEntityCode eq '"+partnerInfoContext.partner.legalEntityCode+"' and businessLineCode eq 'SO-SMART'";

    return (
        <PageContainer pageType={SystemPageType.Card} title={t('partnerCenter:partnerItemCard:title')!} endpoint="odata/partner/item" ref={ref}>
            <CardGroup name="general" label={t('partnerCenter:partnerItemCard:groups:general')!} isOpen>
                <CardField name="itemId" type={SystemFieldType.Option} label={t('partnerCenter:partnerItemCard:fields:itemId')!} hasTableRelation tableRelationEndpoint="/odata/item" tableRelationKey="id" tableRelationField="description" tableRelationFilter={buildItemFilter()} />
                <CardField name="partnerItemNo" type={SystemFieldType.String} label={t('partnerCenter:partnerItemCard:fields:partnerItemNo')!} />
            </CardGroup>
        </PageContainer>
    );
});